import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from 'react';
import { dataByGroup as emojiJSON } from '../constants/dataByGroup';
const EmojiPickerContext = createContext({});
export const filterDoNotDisplayEmojis = (emojis, doNotDisplay = []) => Object.fromEntries(Object.entries(emojis).map(([groupName, emojiList]) => [
    groupName,
    emojiList.filter((emoji) => !doNotDisplay.includes(emoji.slug)),
]));
export const EmojiPickerProvider = ({ children, doNotDisplay, emojiSelectionLabel, maxVersion, onEmojiPick, }) => {
    const emojiData = useMemo(() => filterDoNotDisplayEmojis(emojiJSON, doNotDisplay), [doNotDisplay]);
    const emojiGroupListData = Object.keys(emojiJSON);
    const [selectedEmojiGroup, setSelectedEmojiGroup] = useState(emojiGroupListData[0]);
    const [previewEmoji, setPreviewEmoji] = useState();
    const [focusedEmoji, setFocusedEmoji] = useState();
    const [emojiGroupWrapperRefs, setEmojiGroupWrapperRefs] = useState({});
    const addEmojiGroupWrapperRef = useCallback((groupName, ref) => {
        setEmojiGroupWrapperRefs((prev) => (Object.assign(Object.assign({}, prev), { [groupName]: ref })));
    }, []);
    const value = useMemo(() => ({
        addEmojiGroupWrapperRef,
        emojiData,
        emojiGroupWrapperRefs,
        emojiSelectionLabel,
        focusedEmoji,
        maxVersion,
        onEmojiPick,
        previewEmoji,
        selectedEmojiGroup,
        setFocusedEmoji,
        setPreviewEmoji,
        setSelectedEmojiGroup,
    }), [
        addEmojiGroupWrapperRef,
        emojiData,
        emojiGroupWrapperRefs,
        emojiSelectionLabel,
        focusedEmoji,
        maxVersion,
        onEmojiPick,
        previewEmoji,
        selectedEmojiGroup,
        setFocusedEmoji,
        setPreviewEmoji,
        setSelectedEmojiGroup,
    ]);
    return (_jsx(EmojiPickerContext.Provider, { value: value, children: children }));
};
export const useEmojiPickerContext = () => useContext(EmojiPickerContext);
//# sourceMappingURL=EmojiPickerContext.js.map